export const SOCIAL_LINKS = [
  {
    id: 1,
    path: '/images/icon-facebook.svg',
    href: 'https://www.facebook.com/',
    alt: 'Facebook icon',
  },
  {
    id: 2,
    path: '/images/icon-twitter.svg',
    href: 'https://twitter.com/',
    alt: 'Twitter icon',
  },
  {
    id: 3,
    path: '/images/icon-linkedin.svg',
    href: 'https://www.linkedin.com/',
    alt: 'Linkedin icon',
  },
  {
    id: 4,
    path: '/images/icon-youtube.svg',
    href: 'https://www.youtube.com/',
    alt: 'Youtube icon',
  },
  {
    id: 5,
    path: '/images/icon-dribble.svg',
    href: 'https://dribbble.com/',
    alt: 'Dribble icon',
  },
  {
    id: 6,
    path: '/images/icon-behance.svg',
    href: 'https://www.behance.net/',
    alt: 'Behance icon',
  },
];
